import { useTranslation, Trans } from 'react-i18next';

const VerificationTimeoutModal = ({ isOpen }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleUnderstood = () => {
    window.location.href = '/';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            {t('verification_timeout_title')}
          </h2>
          <p className="text-gray-600 mb-8 whitespace-pre-wrap">
            <Trans i18nKey="verification_timeout_message" />
          </p>
          <button
            onClick={handleUnderstood}
            className="bg-primaryblue hover:bg-primaryblue-dark text-white font-bold py-3 px-6 w-full transition border-none cursor-pointer"
          >
            {t('understood') || 'Understood'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationTimeoutModal;
